export enum FiscalEnvironmentEnum {
  HOMOLOCATION = 'HOMOLOGAÇÃO',
  PRODUCTION = 'PRODUÇÃO',
}

export enum FiscalEnvironmentIdEnum {
  'HOMOLOGAÇÃO' = 1,
  'PRODUÇÃO' = 2,
}

export function getFiscalEnvironmentDescriptionByValue(value: number) {
  const indexOfS = Object.values(FiscalEnvironmentIdEnum).indexOf(
    value as unknown as FiscalEnvironmentIdEnum
  );

  const key = Object.keys(FiscalEnvironmentIdEnum)[indexOfS];

  return key;
}


